import { render, staticRenderFns } from "./UsersMore.vue?vue&type=template&id=12872b4f&"
import script from "./UsersMore.vue?vue&type=script&lang=js&"
export * from "./UsersMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports